import {
  AVAILABILITY_SUMMARY,
  CANCEL_RESERVATION_FAILED,
  CANCEL_RESERVATION_SUCCESS,
  FETCH_CALCULATED_PRICE_FAILURE,
  FETCH_CALCULATED_PRICE_REQUEST,
  FETCH_CALCULATED_PRICE_SUCCESS,
  RESERVATION_DETAILS,
  RESERVATION_LIST_DATA,
  RESERVATION_PRICING_LIST,
  RESERVATION_REQUEST,
  RESERVATION_REQUEST_FAILED,
  RESERVATION_REQUEST_SUCEESS,
  RES_LOCATION_LIST,
  RES_LOCATION_LIST_REQUEST,
  SAVE_RESERVATION_STATE_DATA,
  SCHEDULE_MOVE_OUT_FAILURE,
  SCHEDULE_MOVE_OUT_SUCCESS,
  SET_SELECTED_RESERVATION_DETAILS,
  LOCATION_GATE_LIST_DATA,
  FETCH_GATELIST_REQUEST_FAILED,
  SET_SELECTED_GATES,
  SPOT_THRESHOLD,
} from "../constants";
import apiConfig from "../../../services/apiManager/apiConfig";
import {
  getRequestAuthenticationRequest,
  postAuthenticationRequest,
} from "../../../services/apiManager/apiRequests";
import { enqueueSnackbar } from "notistack";
import SnackbarConfig from "../../../utils/snackbarConfig";
import { substituteUrlParams } from "../../../services/apiManager/helper";
import errorHandler from "../../../services/apiManager/responseHandlers/errorHandler";
import { sendMessageToReactNative } from "../../../utils";

export const getLocationList =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: RESERVATION_REQUEST,
        payload: { isLoading: true },
      });
      const response = await getRequestAuthenticationRequest(
        apiConfig.reservationApis.locations,
        params,
      );
      if (response) {
        dispatch({
          type: RES_LOCATION_LIST,
          payload: response,
        });
        callback(response);
      } else {
        dispatch({
          type: RES_LOCATION_LIST_REQUEST,
          payload: {},
        });
        callback({});
      }
    } catch (error) {
      callback({});
      dispatch({
        type: RES_LOCATION_LIST_REQUEST,
        payload: {},
      });
    }
  };

export const reservationsPricingRequest =
  (locId, callback = () => {}) =>
  async (dispatch) => {
    const apiUrl = `${apiConfig.reservationApis.pricingList}/${locId}`;
    try {
      dispatch({
        type: RESERVATION_REQUEST,
        payload: { isLoading: true },
      });
      const response = await getRequestAuthenticationRequest(apiUrl, {});
      if (response) {
        dispatch({
          type: RESERVATION_PRICING_LIST,
          payload: response?.pricingList,
        });
        callback(response);
      } else {
        callback({});
        dispatch({
          type: RESERVATION_REQUEST_FAILED,
          payload: {},
        });
      }
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.errMsg, {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
      dispatch({
        type: RESERVATION_REQUEST_FAILED,
        payload: {},
      });
    }
  };

export const reservationsBookRequest =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: RESERVATION_REQUEST,
        payload: { isLoading: true },
      });
      const response = await postAuthenticationRequest(
        apiConfig.reservationApis.reservations,
        params,
      );
      if (response?.customerId) {
        dispatch({
          type: RESERVATION_REQUEST_SUCEESS,
          payload: response,
        });
        callback(response);
      } else {
        dispatch({
          type: RESERVATION_REQUEST_FAILED,
          payload: {},
        });
        callback({});
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errMsg || error?.response?.data?.message;
      enqueueSnackbar(errMsg, {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
      dispatch({
        type: RESERVATION_REQUEST_FAILED,
        payload: {},
      });
    }
  };

export const fetchCalculatedPricesRequest =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: FETCH_CALCULATED_PRICE_REQUEST,
        payload: { isLoading: true },
      });
      const response = await postAuthenticationRequest(
        apiConfig.reservationApis.calculatedPrice,
        params,
      );
      if (response?.totalNetAmt) {
        dispatch({
          type: FETCH_CALCULATED_PRICE_SUCCESS,
          payload: response,
        });
        callback(response);
      } else {
        dispatch({
          type: FETCH_CALCULATED_PRICE_FAILURE,
          payload: {},
        });
        callback({});
      }
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.message, {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
      dispatch({
        type: FETCH_CALCULATED_PRICE_FAILURE,
        payload: {},
      });
    }
  };

export const reservationsDetailsRequest =
  (reservation_id, callback = () => {}) =>
  async (dispatch) => {
    const apiUrl = `${apiConfig.reservationApis.reservationsDetails}/${reservation_id}`;
    try {
      dispatch({
        type: RESERVATION_REQUEST,
        payload: { isLoading: true },
      });
      const response = await getRequestAuthenticationRequest(apiUrl, {});
      if (response?.customerId) {
        dispatch({
          type: RESERVATION_DETAILS,
          payload: response,
        });

        callback(response);
      }
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.errMsg, { variant: "error" });
      // callback({});
      dispatch({
        type: RESERVATION_REQUEST_FAILED,
        payload: {},
      });
    }
  };

export const availabilitySummaryRequest =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: RESERVATION_REQUEST,
        payload: { isLoading: true },
      });
      const response = await getRequestAuthenticationRequest(
        apiConfig.reservationApis.availabilityThresholdSummary,
        params,
      );
      if (
        response?.availabilitySummary?.availabilitySummary &&
        response?.spotCounts
      ) {
        dispatch({
          type: AVAILABILITY_SUMMARY,
          payload: response.availabilitySummary.availabilitySummary,
        });
        dispatch({
          type: SPOT_THRESHOLD,
          payload: response.spotCounts,
        });
        callback(response);
      } else {
        callback({});
      }
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.errMsg, {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
      dispatch({
        type: RESERVATION_REQUEST_FAILED,
        payload: {},
      });
    }
  };

export const getReserverationList =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: RESERVATION_REQUEST,
        payload: { isLoading: true },
      });
      const response = await getRequestAuthenticationRequest(
        apiConfig.reservationApis.reservationsList,
        params,
      );
      if (response?.response?.docs?.length) {
        dispatch({
          type: RESERVATION_LIST_DATA,
          payload: response?.response?.docs,
        });
        callback(response);
      } else {
        callback({});
        dispatch({
          type: RESERVATION_REQUEST_FAILED,
          payload: {},
        });
      }
    } catch (error) {
      enqueueSnackbar("Failed to fetch reservations data", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
      dispatch({
        type: RESERVATION_REQUEST_FAILED,
        payload: {},
      });
    }
  };

export const getLocationSolrListApi =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: RESERVATION_REQUEST,
        payload: { isLoading: true },
      });
      const response = await getRequestAuthenticationRequest(
        apiConfig.reservationApis.locationSolrList,
        params,
      );
      if (response?.response?.docs) {
        dispatch({
          type: RES_LOCATION_LIST,
          payload: response?.response?.docs,
        });

        callback(response?.response?.docs);
      } else {
        enqueueSnackbar("Failed to fetch location data", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
        dispatch({
          type: RESERVATION_REQUEST_FAILED,
          payload: {},
        });
        callback({});
      }
    } catch (error) {
      enqueueSnackbar("Failed to fetch location data", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
      dispatch({
        type: RESERVATION_REQUEST_FAILED,
        payload: {},
      });
    }
  };

export const extendReservation =
  ({ reservationId, numOfDays }, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: RESERVATION_REQUEST,
        payload: { isLoading: true },
      });

      const apiUrl = substituteUrlParams(
        apiConfig.reservationApis.extendReservation,
        { reservationId, numOfDays },
      );

      const response = await postAuthenticationRequest(apiUrl);

      dispatch({
        type: RES_LOCATION_LIST,
        payload: response,
      });

      callback(response);
    } catch (error) {
      const errorMsg = errorHandler(error);
      enqueueSnackbar(errorMsg, {
        variant: "error",
      });
      callback(false);
      dispatch({
        type: RESERVATION_REQUEST_FAILED,
        payload: {},
      });
    }
  };

export const cancelReservationRequest =
  ({ reservationId, extension = false }, params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: RESERVATION_REQUEST,
        payload: { isLoading: true },
      });

      const apiUrl = substituteUrlParams(
        apiConfig.reservationApis.cancelReservation,
        { reservationId, extension },
      );

      const response = await postAuthenticationRequest(apiUrl, params);

      if (Object.keys(response)?.length > 0) {
        dispatch({
          type: CANCEL_RESERVATION_SUCCESS,
          payload: response,
        });
        callback({ success: response });
      } else {
        dispatch({
          type: CANCEL_RESERVATION_SUCCESS,
          payload: {},
        });
        callback({ success: "SUCCESS" });
      }
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.message, {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({ error: error?.response?.data?.message });
      dispatch({
        type: CANCEL_RESERVATION_FAILED,
        payload: {},
      });
    }
  };

export const scheduleMoveOutRequest =
  ({ reservationId }, params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: RESERVATION_REQUEST,
        payload: { isLoading: true },
      });

      const apiUrl = substituteUrlParams(
        apiConfig.reservationApis.scheduleMoveOut,
        { reservationId },
      );

      const response = await postAuthenticationRequest(apiUrl, params);

      if (Object.keys(response)?.length > 0) {
        dispatch({
          type: SCHEDULE_MOVE_OUT_SUCCESS,
          payload: response,
        });
        callback({ success: response });
      } else {
        dispatch({
          type: SCHEDULE_MOVE_OUT_SUCCESS,
          payload: {},
        });
        callback({ success: "SUCCESS" });
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errMsg || error?.response?.data?.message;
      enqueueSnackbar(errMsg, {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({ error: errMsg });
      dispatch({
        type: SCHEDULE_MOVE_OUT_FAILURE,
        payload: {},
      });
    }
  };

export const doOpenGate =
  (params, callback = () => {}, cbp = () => {}) =>
  async (dispatch) => {
    const doOpenGateURL = `${apiConfig.reservationApis.openGate}/${params?.reservationId}/gates/${params?.gateId}/open?deviceLatitude=${params?.lat}&deviceLongitude=${params?.lng}&fetchLatLongTimeInMillis=${params?.fetchLatLongTimeInMillis}`;
    try {
      const response = await postAuthenticationRequest(doOpenGateURL, params);
      callback(response);
      cbp(false);
      enqueueSnackbar(`Gate number ${params?.gateId} opened`, {
        variant: "success",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
    } catch (error) {
      enqueueSnackbar(
        error?.response?.data?.errMsg || "Failed to fetch gate access details",
        {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        },
      );
      callback({});
      cbp(false);
    }
  };

export const getLocationGatesListOld =
  (params, callback = () => {}) =>
  async (dispatch) => {
    const reservationLocationObj = params?.reservation_json
      ? JSON.parse(params?.reservation_json)
      : "";
    const getGatesOfLocationURL = `${apiConfig?.reservationApis?.locationGatestList}${reservationLocationObj[0]?.locationId}`;
    try {
      const response = await getRequestAuthenticationRequest(
        getGatesOfLocationURL,
        {},
      );
      callback(response);
    } catch (error) {
      enqueueSnackbar("Failed to fetch List of gate", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
    }
  };
export const saveReservationStateData = (data) => ({
  type: SAVE_RESERVATION_STATE_DATA,
  payload: data,
});
export const setSelectedReservationItem = (reservation) => ({
  type: SET_SELECTED_RESERVATION_DETAILS,
  payload: reservation,
});
export const getLocationGatesList =
  (params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: RESERVATION_REQUEST,
        payload: { isLoading: true },
      });
      const data = await getRequestAuthenticationRequest(
        apiConfig.reservationApis.locationGatestListSolr,
        params,
      );
      if (data?.response?.docs?.length) {
        dispatch({
          type: LOCATION_GATE_LIST_DATA,
          payload: data.response?.docs,
        });
        callback(data);
      } else {
        callback({});
        dispatch({
          type: FETCH_GATELIST_REQUEST_FAILED,
          payload: [],
        });
      }
    } catch (error) {
      enqueueSnackbar("Failed to fetch List of gate", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
      dispatch({
        type: FETCH_GATELIST_REQUEST_FAILED,
        payload: [],
      });
    }
  };
export const setSelectedGates = (gates) => ({
  type: SET_SELECTED_GATES,
  payload: gates,
});
